import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DefaultLayout as PDP, ReducedPDP, FullBleedLayout } from '../../components/product-details-page';
import { pdpActions, pdpSelectors } from '../../redux/product-details-state';
import { RetryErrorPage } from '@ynap/error-page';
import track from 'react-tracking';
import { MetaTags } from '@ynap/meta-tags';
import { getErrors } from 'app/redux/selectors';
import { getPDPSchemaMetaData } from '../../utils/getSchemaMetaData';
import { productActions } from 'app/redux/product-state';
import { fetchUserFromSF, setUser } from '@ynap/user-state';
import { constructUrl } from '@ynap/url-configuration';
import { StatusPage } from '../../components/StatusPage';
import { trackPageView } from '../../analytics';
import { Redirect } from 'react-router-dom';
import { plpActions } from '../../redux/product-listing-state';
import { Features, FeatureSelectorProviderWrapper } from '@ynap/feature-selector';
import { Notification } from '@ynap/notification';
import { raygun } from '@ynap/clientside-monitoring';
import featuresList from '../../features';
import { PDPSkeleton } from '../../components/PDPSkeleton';
import { addToCart } from '@ynap/cart-state';
import { addToWishlistAction as addToWishlist, fetchNavigation as fetchWishlists } from '@ynap/wishlist-state';
import { redirectToCheckout, redirectToWishlist } from '@ynap/redirect-utils';
import { addFitAnalyticsObject } from './third-party';
import { withOptimizely, OptimizelyFeature, trackPage as trackPageOptimizely } from '@ynap/optimizely-utils';
import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi';
import { getSelectedPromoPrice } from 'app/redux/product-details-state/selectors/getPromo';

const { getProductDetails, changeSelectedPartNumber, changeSelectedSku, resetProductState, updatePromoPrice } = pdpActions;
const { getSelectedProduct, getProductWithMappedCategories, getLoading, checkRedirect, getCurrentMetaData } = pdpSelectors;
const { setMessages, setClickedPidOnPLP } = productActions.appState;
const { setPLPProducts, resetPLPState } = plpActions;

function mapStateToProps(state, props) {
    const { pdp: pdpState, userState, appState, fetchWishlists, notificationState: { notification } = {} } = state;
    const { wishlistsList } = fetchWishlists || {};
    const { error, response } = pdpState.detailsState;
    const responseStatus = response && response.status;
    const appLoading = getLoading(state, props);
    const geoIP = props?.geoIP || '';

    const {
        cart: addToCart,
        addToWishlist,
        config,
        appState: { region, locale, country, language, langISO, prevPath, dir },
    } = state;

    if (error || appLoading) return { responseError: error, loading: appLoading, responseStatus, prevPath };

    const product = getSelectedProduct(state, props);

    if (!product) return { productError: true, loading: false, responseStatus: 404, prevPath };
    //TODO: Put this into the variant selector
    const salesCategories = response.body.products[0] && response.body.products[0].salesCategories;
    const masterCategory = [response.body.products[0] && response.body.products[0].masterCategory];
    const mappedCategories = salesCategories && getProductWithMappedCategories(salesCategories);
    const trackingCategories =
        (masterCategory[0] && Object.keys(masterCategory[0]).length && getProductWithMappedCategories(masterCategory)) || mappedCategories;
    const { user, userFetchedFromSF } = userState;
    const wishlistUrlTemplate = constructUrl(config.global.urlConfig.wishlist ? config.global.urlConfig.wishlist.construct : '', { LOCALE: locale });
    const redirect = checkRedirect(product.seo, props.match, config.global.urlConfig.pdp.construct, locale);
    const metaIndex = !product.soldOutOnline && redirect.metaIndex;
    const metaData = getCurrentMetaData(redirect.productLvlPid, metaIndex, product, config);
    const promoPrice = getSelectedPromoPrice(state, product.sKUs?.[0]?.partNumber);

    return {
        product,
        metaData,
        redirect,
        // TODO: put into getSelectedProduct selector
        mappedCategories,
        trackingCategories,
        actionsErrors: getErrors({ addToCart, addToWishlist, fetchWishlists }),
        actionsLoading: { addToCartLoading: addToCart.loading, addToWishlistLoading: addToWishlist.loading, fetchWishlistsLoading: fetchWishlists?.loading },
        region,
        locale,
        config,
        appState,
        user,
        userFetchedFromSF,
        responseError: error,
        loading: false,
        wishlistUrlTemplate,
        country,
        language,
        langISO,
        prevPath,
        wishlists: wishlistsList,
        ssr: props.ssr,
        geoIP,
        notification,
        promoPrice,
        dir,
    };
}

function mapDispatchToProps() {
    return {
        getProductDetails,
        changeSelectedPartNumber,
        changeSelectedSku,
        resetProductState,
        addToCart,
        addToWishlist,
        fetchWishlists,
        setMessages,
        fetchUserFromSF,
        setUser,
        setPLPProducts,
        setClickedPidOnPLP,
        resetPLPState,
        updatePromoPrice,
    };
}

@track({ lpTag: { additionalSections: ['product details page'] } })
export class PDPContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasExternalReferrer: false,
            badgesProcessed: false,
            showReducedMode: props?.product?.soldOutOnline || false,
            applyFounditCarousel: false,
            wasReducedPDP: false,
            isDesktop: null,
        };

        this.selectItem = this.selectItem.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { messages, setMessages } = this.props;

        setMessages(messages);
    }

    componentDidMount() {
        const { loading, responseError, fetchUserFromSF, product, config, optimizely, prevPath, language, country, metaData } = this.props;

        const { fitAnalytics } = config.head.pdp;

        fitAnalytics?.script && this.fitAnalyticsConsent(fitAnalytics);

        if (product?.soldOutOnline) {
            this.setState({
                showReducedMode: true,
            });
        }

        const hasExternalReferrer = !!(
            prevPath === null &&
            document.referrer &&
            !config.head.seo.internalUrls?.find((internalUrl) => document.referrer.includes(internalUrl))
        );

        this.setState({
            hasExternalReferrer,
        });

        //Remove addToWishlist query after page load
        //TODO remove this when we move to use the sifu login pop up instead
        const uri = window.location.toString();
        const queryIndex = uri.indexOf('?mode=addToWishlist');
        if (queryIndex > 0) {
            const clean_uri = uri.substring(0, queryIndex);
            window.history.replaceState({}, document.title, clean_uri);
        }
        if (loading) {
            return this.fetchProductDetails();
        }
        fetchUserFromSF(product?.forceLogIn);
        // Fire analytics - Will only reach if state matches page data.
        if (!responseError) {
            window.performance.mark('spaIntTime');
            trackPageView(this.props);
            if (fitAnalytics?.object) {
                const shopSessionId = getCookie('_ga');
                addFitAnalyticsObject({ language, country, product, shopSessionId, metaData, selectItem: this.selectItem, fitAnalytics });
            }

            if (optimizely) {
                trackPageOptimizely(optimizely, 'pdp');
                const categories = product?.masterCategory
                    ?.map((category) => category.labelEN)
                    .toString()
                    .toLowerCase();

                optimizely?.onReady?.()?.then?.(() => {
                    optimizely?.setUser?.({
                        id: optimizely?.user?.id,
                        attributes: {
                            ...optimizely?.user?.attributes,
                            price: product?.price?.finalPrice || 0,
                            isOneSize: product?.isOneSize,
                            designer: product?.designerName?.toLowerCase(),
                            category: categories,
                            colourPartNumber: product?.colourPartNumber,
                            soldOut: !!product?.soldOutOnline,
                        },
                    });
                });
            }
        }
        // try/catch just deals with converting old recently viewed localStorage to new format
        try {
            const sfRecentlyViewedProducts = JSON.parse(localStorage.getItem('sf_recentlyViewed'));
            if (sfRecentlyViewedProducts?.length > 0) {
                const modelPartNumbers = sfRecentlyViewedProducts
                    .map((i) => {
                        return Object.hasOwn(i, 'modelPartNumber') && typeof i.modelPartNumber === 'string' ? i.modelPartNumber : null;
                    })
                    .filter(Boolean)
                    .reverse(); // old storage was in reverse order to what we want to display

                // ensure we only store max 7 items
                localStorage.setItem('recentlyViewedPartNumbers', JSON.stringify(modelPartNumbers.slice(0, 7).map((i) => [i, i])));
            }
            localStorage.removeItem('sf_recentlyViewed');
        } catch (error) {
            raygun.helpers.agent('send', {
                error,
                tags: ['PDP'],
            });
        }
        this.storeRecentlyViewedProducts(product);

        if (typeof window !== 'undefined') {
            // Adds the product sizeMapping to be used by DeepGears on add to cart
            window.productSizeMapping = this.getProductSizeMapping(product?.sKUs);

            this.mediaQuery = window?.matchMedia?.('(min-width: 1024px)');
            this.handleMediaChange(this.mediaQuery);
            this.mediaQuery.addEventListener('change', this.handleMediaChange);
        }
    }

    componentWillUnmount() {
        this.props.resetProductState();

        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            loading,
            responseError,
            match: {
                params: { PART_NUMBER },
            },
            changeSelectedPartNumber,
            product,
            setClickedPidOnPLP,
            setPLPProducts,
            optimizely,
            config,
            language,
            country,
            metaData,
            location: { pathname, search },
            updatePromoPrice,
            user,
        } = this.props;

        const {
            loading: prevLoading,
            match: {
                params: { PART_NUMBER: PREV_PART_NUMBER },
            },
            product: prevProduct,
            user: prevUser,
        } = prevProps;

        const { fitAnalytics } = config.head.pdp;

        //when pdp data is fetched, set clicked pid on plp and reshape plp products state
        if (!loading && prevLoading && product) {
            setClickedPidOnPLP(product.colourPartNumber);
            setPLPProducts(product.colourPartNumber);
        }

        if ((!loading && prevLoading) || (product && prevProduct && product.colourPartNumber !== prevProduct.colourPartNumber)) {
            window.performance.mark('spaIntTime');
            trackPageView(this.props);
            this.setState({
                showReducedMode: !!product?.soldOutOnline,
            });
            if (fitAnalytics?.object) {
                const shopSessionId = getCookie('_ga');
                addFitAnalyticsObject({ language, country, product, shopSessionId, metaData, selectItem: this.selectItem, fitAnalytics });
            }
            if (optimizely) {
                trackPageOptimizely(optimizely, 'pdp');
                optimizely?.onReady?.()?.then?.(() => {
                    optimizely?.setUser?.({
                        id: optimizely?.user?.id,
                        attributes: {
                            ...optimizely?.user?.attributes,
                            price: product?.price?.finalPrice || 0,
                            isOneSize: product?.isOneSize,
                            designer: product?.designerName?.toLowerCase(),
                            category: product?.masterCategory
                                ?.map((category) => category.labelEN)
                                .toString()
                                .toLowerCase(),
                            colourPartNumber: product?.colourPartNumber,
                            soldOut: !!product?.soldOutOnline,
                        },
                    });
                });
            }
            this.storeRecentlyViewedProducts(product);

            // Adds the product sizeMapping to be used by DeepGears on add to cart
            window.productSizeMapping = this.getProductSizeMapping(product?.sKUs);

            this.mediaQuery = window?.matchMedia?.('(min-width: 1024px)');
            this.handleMediaChange(this.mediaQuery);
            this.mediaQuery.addEventListener('change', this.handleMediaChange);
        }

        if ((!prevUser && user) || (product && prevProduct && product.colourPartNumber !== prevProduct.colourPartNumber)) {
            updatePromoPrice(product?.sKUs?.[0]?.partNumber, pathname + search, user?.globalId);
        }

        if (PART_NUMBER !== PREV_PART_NUMBER) {
            // Remove the EntryPage AB test on SPA render (YMAL click)
            if (this.state.hasExternalReferrer) {
                this.setState({
                    hasExternalReferrer: false,
                });
            }

            if (this.state.wasReducedPDP) {
                this.setState({
                    wasReducedPDP: false,
                });
            }

            if (loading || responseError) {
                this.fetchProductDetails();
                return;
            }

            // Route change via colour swatch selector, so update selectedPartNumber to correct colour in state
            return changeSelectedPartNumber(PART_NUMBER);
        }

        if (
            product &&
            prevProduct &&
            product.colourPartNumber === prevProduct.colourPartNumber &&
            !this.state.hasExternalReferrer &&
            prevState?.hasExternalReferrer
        ) {
            this.setState({
                wasReducedPDP: true,
            });
        }

        // Check if user comes from non-restricted to restricted product
        if (product?.forceLogIn && !prevProduct?.forceLogIn) {
            fetchUserFromSF(product.forceLogIn);
        }

        prevState?.applyFounditCarousel === false && this.state.applyFounditCarousel === true && import('./third-party/founditCarousel');
    }

    storeRecentlyViewedProducts(product) {
        try {
            if (product) {
                const partNumbers = JSON.parse(localStorage.getItem('recentlyViewedPartNumbers')) || [];

                // We only care about the last 7 items
                const truncatedPartNumbers = partNumbers.slice(0, 7);

                // Remove the modelPartNumber if it exists
                const existingIdx = truncatedPartNumbers.findIndex((i) => i[0] === product.modelPartNumber);
                truncatedPartNumbers.splice(existingIdx, ~existingIdx ? 1 : 0);

                // Add to the front
                truncatedPartNumbers.unshift([product.modelPartNumber, product.colourPartNumber]);

                localStorage.setItem('recentlyViewedPartNumbers', JSON.stringify(truncatedPartNumbers.slice(0, 7)));
            }
        } catch (error) {
            raygun.helpers.agent('send', {
                error,
                tags: ['PDP'],
            });
        }
    }

    fetchProductDetails(props = this.props) {
        const {
            location: { pathname, search },
            match: {
                params: { PART_NUMBER },
            },
        } = props;
        props.getProductDetails(PART_NUMBER, pathname + search).catch(/* istanbul ignore next - No need to test catch promise */ (err) => err);
    }

    selectItem(itemId, label) {
        const { changeSelectedSku, product } = this.props;
        if (product && product.sKUs) {
            const selectedSku = product.sKUs.find((sku) => sku.partNumber === itemId && sku.size.labelSize === label);
            if (selectedSku) {
                changeSelectedSku(selectedSku);
            }
        }
    }

    fitAnalyticsConsent(fitAnalyticsConfig) {
        if (typeof window.cact !== 'undefined') {
            try {
                window.cact('consent.get', ({ consent }) => {
                    const fitAnalyticsCategory = consent.categories[fitAnalyticsConfig.privacyId] || {};
                    if (fitAnalyticsCategory.status === 'on') {
                        import('./third-party/fitAnalyticsPDPScript');
                    }
                });
            } catch (error) {
                raygun.helpers.agent('send', {
                    error,
                    tags: ['PDP', 'fitAnalytics', 'consentFail'],
                });
            }
        } else {
            import('./third-party/fitAnalyticsPDPScript');
        }
    }

    getProductSizeMapping(skus) {
        const result = {};
        skus?.forEach((sku) => {
            const size = sku?.size?.centralSizeLabel || sku?.size?.labelSize;
            if (size && sku.partNumber) {
                result[size.toString().toLowerCase()] = {
                    partNumber: sku.partNumber,
                    buyable: sku.buyable,
                    label: size,
                    redirectUrl: this.generateLoginRedirect(sku.partNumber),
                };
            }
        });
        return result;
    }

    generateLoginRedirect = (skuPartNumber) => {
        const locale = document?.body?.attributes?.['data-locale']?.value;
        const redirectUrlTemplate = `/${locale}/mens/product/${skuPartNumber}?mode=addToWishlist`;
        const redirect = encodeURIComponent(redirectUrlTemplate);
        return `/${locale}/account/login?redirect=${redirect}`;
    };

    handleMediaChange(event) {
        this.setState({ isDesktop: event.matches });
    }

    render() {
        const {
            messages,
            loading,
            product,
            changeSelectedPartNumber,
            changeSelectedSku,
            region,
            locale,
            addToCart,
            addToWishlist,
            fetchWishlists,
            config,
            responseError,
            productError,
            mappedCategories,
            actionsErrors,
            actionsLoading,
            responseStatus,
            wishlistUrlTemplate,
            redirect,
            userFetchedFromSF,
            setUser,
            location,
            metaData,
            country,
            language,
            langISO,
            prevPath,
            wishlists,
            ssr,
            resetPLPState,
            geoIP,
            notification,
            tracking,
            promoPrice,
            appState,
            dir,
        } = this.props;

        const internal_urls = ['pdp', 'plp', 'azdesigners', 'whatsnew'];
        const urlContactCustomerCare = config.head.pdp.urlCustomerCare && config.head.pdp.urlCustomerCare.replace(':locale', locale);
        const urlCustomerReturns = config.head.pdp.urlCustomerReturns && config.head.pdp.urlCustomerReturns.replace(':locale', locale);
        const brandId = config.global.application.brandId;

        const schemaMetaData = getPDPSchemaMetaData(config, product, messages, metaData, promoPrice, appState);

        if (productError || (responseError && responseStatus >= 400 && responseStatus < 500)) {
            return <StatusPage code={responseStatus} displayMessage={messages.error.notFound()} actionLabel={messages.error.goBack()} prevPath={prevPath} />;
        }
        if (responseError) {
            return (
                <RetryErrorPage
                    messages={messages}
                    maxRetries={config.head.errorPage.maxRetries}
                    backoff={config.head.errorPage.backoff}
                    action={() => this.fetchProductDetails()}
                    tracking={tracking}
                />
            );
        }

        if (redirect?.shouldRedirect) {
            return (
                <Redirect
                    to={{
                        pathname: redirect.redirectUrl,
                        search: location.search,
                        state: { statusCode: config.head.redirects.statusCode },
                    }}
                />
            );
        }

        const isLuxBrand = brandId === 'nap' || brandId === 'mrp';
        // To prevent layout shift during client-side rendering, we use a skeleton to avoid flash between desktop and mobile versions. TON doesn't need a skeleton.
        if (loading || (this.state.isDesktop === null && isLuxBrand)) {
            return <PDPSkeleton />;
        }

        const { sizeGridFeatureToggle, bypassWCSRecommendations, optimizely, multipleWishlistsFeatureToggle, allow1stLevelZoom, fullBleedEnabledCountries } =
            config.head.pdp;
        const { og: ogMetaData } = metaData;
        // TODO: config can be removed after succesful release
        const soldOutReducedModeEnabled = this.state.showReducedMode && config?.head?.pdp?.soldOutReducedMode;
        const isFullbleedEnabledInCurrentCountry = fullBleedEnabledCountries?.includes(country);

        const commonPdpProps = {
            actionsErrors,
            actionsLoading,
            addToCart,
            addToWishlist,
            allow1stLevelZoom,
            baseUrl: config.head?.seo?.baseUrl,
            brandId,
            bypassWCSRecommendations: bypassWCSRecommendations,
            changeSelectedPartNumber,
            changeSelectedSku,
            country,
            fetchWishlists,
            generateListingUrl: constructUrl,
            geoIP,
            internal_urls,
            langISO,
            language,
            locale,
            mappedCategories,
            messages,
            multipleWishlistsFeatureToggle,
            ogMetaData,
            optimizely: this.props.optimizely,
            pdpUrlTemplate: config.global.urlConfig.pdp.construct,
            plpUrlTemplate: config.global.urlConfig.plp.construct,
            product,
            redirectToCheckout,
            redirectToWishlist,
            region,
            resetPLPState,
            urlConfig: config.global.urlConfig,
            setUser,
            sizeGridFeatureToggle,
            ssr,
            urlContactCustomerCare,
            urlCustomerReturns,
            userFetchedFromSF,
            wishlists,
            wishlistUrlTemplate,
            wasReducedPDP: this.state.wasReducedPDP,
            promoPrice,
            isRTL: dir === 'rtl',
        };

        return (
            <FeatureSelectorProviderWrapper
                features={featuresList(config)}
                categories={product.masterCategory ? product.masterCategory.map((cat) => cat.identifier) : []}
            >
                <>
                    <MetaTags schemaMetaData={schemaMetaData} metaData={metaData} script={optimizely} toPreconnect={config.head?.preconnectTags} />
                    {notification?.name === 'action' && <Notification name={notification.name} type={notification.type} message={notification.message} />}
                    {soldOutReducedModeEnabled ? (
                        <Features>
                            <ReducedPDP
                                {...commonPdpProps}
                                ignoreCategories={config.head.plp.facet.ignoreCategories}
                                setReducedMode={(value) => this.setState({ showReducedMode: value })}
                                soldOut={product.soldOutOnline}
                                tracking={tracking}
                            />
                        </Features>
                    ) : this.state.hasExternalReferrer ? (
                        // TODO: If this test successful refactor to use this.state.showReducedMode when external referrer
                        <OptimizelyFeature feature={['WEB00664_RecEntrypageredesign2_PDP_desktop', 'WEB00665_RecEntrypageredesign2_PDP_mobile']}>
                            {(props) => {
                                const { variationKey } = props;
                                const reducedMode = ['v1_web00664', 'v2_web00664', 'v1_web00665', 'v2_web00665'].includes(variationKey);
                                const applyPdpRedesignV1 = ['v1_web00664', 'v1_web00665'].includes(variationKey);

                                if (applyPdpRedesignV1 && !this.state.applyFounditCarousel) {
                                    this.setState({ applyFounditCarousel: true });
                                }

                                return (
                                    <Features>
                                        {reducedMode ? (
                                            <ReducedPDP
                                                {...commonPdpProps}
                                                ignoreCategories={config.head.plp.facet.ignoreCategories}
                                                setReducedMode={(value) => this.setState({ hasExternalReferrer: value })}
                                                soldOut={false}
                                                tracking={tracking}
                                            />
                                        ) : isFullbleedEnabledInCurrentCountry && !!this.state.isDesktop ? (
                                            <FullBleedLayout
                                                key="fullBleedLayout"
                                                {...commonPdpProps}
                                                config={config}
                                                tracking={tracking}
                                                optimizely={optimizely}
                                            />
                                        ) : (
                                            <PDP {...commonPdpProps} config={config} />
                                        )}
                                    </Features>
                                );
                            }}
                        </OptimizelyFeature>
                    ) : (
                        <>
                            {isFullbleedEnabledInCurrentCountry && !!this.state.isDesktop ? (
                                <Features>
                                    <FullBleedLayout key="fullBleedLayout" {...commonPdpProps} config={config} tracking={tracking} optimizely={optimizely} />
                                </Features>
                            ) : (
                                <Features>
                                    <PDP key="pdp" {...commonPdpProps} config={config} />
                                </Features>
                            )}
                        </>
                    )}
                    <OptimizelyFeature feature="pdp_optimizely_test">{() => <span style={{ display: 'none' }} />}</OptimizelyFeature>
                </>
            </FeatureSelectorProviderWrapper>
        );
    }

    static propTypes = {
        redirect: PropTypes.object.isRequired,
        metaData: PropTypes.object.isRequired,
        userFetchedFromSF: PropTypes.func.isRequired,
        responseStatus: PropTypes.number.isRequired,
        actionsLoading: PropTypes.object.isRequired,
        actionsErrors: PropTypes.object.isRequired,
        changeSelectedSku: PropTypes.func.isRequired,
        productError: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        mappedCategories: PropTypes.array.isRequired,
        messages: PropTypes.object.isRequired,
        responseError: PropTypes.object,
        fetchUserFromSF: PropTypes.func.isRequired,
        product: PropTypes.object,
        setMessages: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        changeSelectedPartNumber: PropTypes.func.isRequired,
        addToCart: PropTypes.func.isRequired,
        addToWishlist: PropTypes.func.isRequired,
        config: PropTypes.object.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            search: PropTypes.string.isRequired,
        }),
        region: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        wishlistUrlTemplate: PropTypes.string.isRequired,
        resetProductState: PropTypes.func.isRequired,
        ssr: PropTypes.bool.isRequired,
        resetPLPState: PropTypes.func.isRequired,
        setClickedPidOnPLP: PropTypes.func.isRequired,
        setPLPProducts: PropTypes.func.isRequired,
        fetchWishlists: PropTypes.func.isRequired,
        country: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        langISO: PropTypes.string.isRequired,
        prevPath: PropTypes.string.isRequired,
        geoIP: PropTypes.string.isRequired,
        wishlists: PropTypes.array.isRequired,
        optimizely: PropTypes.shape({
            setUser: PropTypes.func.isRequired,
            user: PropTypes.PropTypes.shape({
                id: PropTypes.string.isRequired,
                attributes: PropTypes.object.isRequired,
            }),
            onReady: PropTypes.func.isRequired,
        }),
        setUser: PropTypes.func.isRequired,
        notification: PropTypes.object.isRequired,
        tracking: PropTypes.shape({
            trackEvent: PropTypes.func.isRequired,
        }).isRequired,
    };
}

export const PDPContainerWithConnect = connect(mapStateToProps, mapDispatchToProps())(PDPContainer);
export default withOptimizely(PDPContainerWithConnect);
